module.exports = __webpack_public_path__ + "static/img/email.9d4f920e.svg";